import { euroFormat } from "@jog/shared"

export const Money = ({ centAmount }: { centAmount: number }) => {
    return <>{transMoney(centAmount)}</>
}

export const transMoney = (
    cent: number,
    { EUR = true, zeroCents = false }: { EUR?: boolean; zeroCents?: boolean } = {}
): string => {
    if (cent < 0) {
        return `-${transMoney(cent * -1)}`
    }
    const euro = cent < 100 ? 0 : Math.floor(cent / 100)
    const cents = Math.round(cent % 100)
    const format = (t: string) => (EUR ? euroFormat(t) : t)
    if (["FR", "DE"].includes((process.env.NEXT_PUBLIC_COUNTRY || "").toUpperCase())) {
        if (cents === 0) return format(`${euro},00`)
        if (cents < 10) return format(`${euro},0${cents}`)
        return format(`${euro},${cents}`)
    }
    if (cents === 0) return format(`${euro}.${zeroCents ? "00" : "-"}`)
    if (cents < 10) return format(`${euro}.0${cents}`)
    return format(`${euro}.${cents}`)
}
